const headerComponent = document.getElementsByClassName('header')[0];
const mobileOpenFixed = document.querySelector('.profile-mob-open.fixed-btn');
const siteElement = document.querySelector('#site');

if (mobileOpenFixed && siteElement) {
  mobileOpenFixed.addEventListener('click', (e) => {
    e.preventDefault();
    siteElement.style.overflow = 'visible';

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });

      setTimeout(() => {
        siteElement.style.overflow = 'hidden';
      }, 300);
    }, 300);
  });
}

const scrollContainer = () => document.documentElement || document.body;

document.addEventListener('scroll', () => {
  if (scrollContainer().scrollTop > 50) {
    headerComponent.classList.add('scrolled');

    if (mobileOpenFixed) {
      mobileOpenFixed.classList.add('scrolled');
    }

  } else if (scrollContainer().scrollTop == 0) {
    headerComponent.classList.remove('scrolled');

    if (mobileOpenFixed) {
      mobileOpenFixed.classList.remove('scrolled');
    }

  }
});


const mobileMenuStartPoint = parseInt(
  getComputedStyle(document.documentElement).getPropertyValue(
    '--mobile-menu-start-point'
  )
);
let isMobileMenuEnable =
  window.outerWidth <= mobileMenuStartPoint ||
  document.querySelector('.header-mobile');


if (document.querySelector('.menu-dropdown')) {
  const menuDropdownsArr = document.querySelectorAll('.menu-dropdown');
  menuDropdownsArr.forEach((menuDropdown) => {
    const dropdownList = menuDropdown.querySelector('.menu-dropdown__list');

    menuDropdown.addEventListener('click', (e) => {
      if (window.innerWidth <= 1280) {
        if (!menuDropdown.classList.contains('is-active')) {
          e.preventDefault();
          menuDropdown.classList.add('is-active');
          dropdownList.classList.add('is-active');
        } else {
          menuDropdown.classList.remove('is-active');
          dropdownList.classList.remove('is-active');
        }
      }
    });
  });
}

function menuToggleFunc() {
  const menuToggle = document.querySelector('.menu-toggle');
  const navbarNav = document.querySelector('.navbar-nav');
  const headerCloseWrapper = document.querySelector('.header-close-wrapper');

  menuToggle.classList.toggle('active');
  navbarNav.classList.toggle('active');
  headerComponent.classList.toggle('open-menu');
  headerCloseWrapper.classList.toggle('active');
  mobileOpenFixed.classList.toggle('open-menu');

  // LockScroll when burger open and enable when closed and enable scroll on menu
  if (scrollLock.getScrollState()) {
    scrollLock.disablePageScroll(document.querySelector('.navbar-nav .menu'));
    scrollLock.addScrollableSelector('.simplebar-content-wrapper');
  } else {
    scrollLock.enablePageScroll();
  }
}

function updateMenu() {
  isMobileMenuEnable =
    window.outerWidth <= mobileMenuStartPoint ||
    document.querySelector('.mobile-header');

  if (!isMobileMenuEnable) {
    const dropdownMenus = document.querySelectorAll('.dropdown-menu');
    dropdownMenus.forEach((menu) => {
      menu.style.display = '';
    });

    const headerCloseWrapper = document.querySelector('.header-close-wrapper');
    headerCloseWrapper.classList.remove('active');

    const activeMenuItems = document.querySelectorAll('.menu-item.active');
    activeMenuItems.forEach((item) => {
      item.classList.remove('active');
    });

    const navbarNav = document.querySelector('.navbar-nav');
    navbarNav.classList.remove('active');

    headerComponent.classList.remove('open-menu');
    mobileOpenFixed.classList.remove('open-menu');

    const menuToggle = document.querySelector('.menu-toggle');
    menuToggle.classList.remove('active');

    scrollLock.enablePageScroll();
  }
}

window.addEventListener('resize', updateMenu);
window.addEventListener('orientationchange', updateMenu);

const menuToggle = document.querySelector('.menu-toggle');
const headerCloseWrapper = document.querySelector('.header-close-wrapper');




menuToggle.addEventListener('click', menuToggleFunc);
headerCloseWrapper.addEventListener('click', menuToggleFunc);

function headerSticky() {
  let prevScrollPos = window.pageYOffset;


  window.onscroll = () => {
    const currentScrollPos = window.pageYOffset;
    const headerHeight = headerComponent.scrollHeight;
    const mobileOpenFixedNew = document.querySelector('.profile-mob-open.fixed-btn');


    function checkScrollPosition() {
      const scrollPosition = window.scrollY + window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      const triggerPoint = documentHeight - 300;


      if (mobileOpenFixedNew) {
        if (scrollPosition >= triggerPoint) {
          mobileOpenFixed.style.transform = 'translateX(-150%)';
          mobileOpenFixed.style.pointerEvents = 'none';
          mobileOpenFixed.style.transition = 'transform 0.1s';
        } else {
          mobileOpenFixed.style.transform = 'translateX(0)';
          mobileOpenFixed.style.pointerEvents = 'auto';
          mobileOpenFixed.style.transition = 'transform 0.1s';
        }
      }
    }

    window.addEventListener('scroll', checkScrollPosition);

    checkScrollPosition();


    if (window.scrollY > 0) {
      if (prevScrollPos > currentScrollPos) {
        headerComponent.style.top = 0;
        headerComponent.classList.add('scrolled');

        if (mobileOpenFixedNew) {
          mobileOpenFixedNew.classList.add('scrolled');
          mobileOpenFixedNew.style.transform = `translateY(-16px)`;
          mobileOpenFixedNew.style.top = `110px`;
        }

      } else {
        headerComponent.style.top = `-${headerHeight + 3}px`;

        if (mobileOpenFixedNew) {
          mobileOpenFixedNew.style.transform = `translateY(-${headerHeight + 16}px)`
          mobileOpenFixedNew.style.top = `30px`;
        }
      }
    }

    if (window.scrollY === 0) {
      headerComponent.classList.remove('scrolled');

      if (mobileOpenFixedNew) {
        mobileOpenFixedNew.classList.remove('scrolled');
        mobileOpenFixedNew.style.transform = `translateY(0)`;
      }
    }

    prevScrollPos = currentScrollPos;
  };

  if (window.scrollY !== 0) {
    headerComponent.classList.add('scrolled');

    if (mobileOpenFixed) {
      mobileOpenFixed.classList.add('scrolled');
      mobileOpenFixed.style.transform = `translateY(0)`;
    }
  }
}

headerSticky();
